import interactiveLinkService from '@/services/interactive-link.service';

const initialState = {
    status: {
        listProjectsComplete: false,
        getProjectComplete: false,
        executeExportComplete: false,
        createQuickViewUrlComplete: false
    },
    projects: [],
    project: {},
    executeExport: {},
    createQuickViewUrl: {}
};

export const interactiveLinkModule = {
    namespaced: true,
    state: initialState,
    actions: {
        clearProjects({ commit }) {
            commit('clearProjects');
        },
        listProjects({ dispatch, commit }) {
            return new Promise((resolve, reject) => {
                interactiveLinkService.listProjects()
                    .then(result => {
                        commit('populateProjects', result);
                        resolve(result);
                    })
                    .catch(error => {
                        commit('clearProjects');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearProject({ commit }) {
            commit('clearProject');
        },
        getProject({ dispatch, commit }, projectId) {
            return new Promise((resolve, reject) => {
                interactiveLinkService.getProject(projectId)
                    .then(project => {
                        commit('populateProject', project);
                        resolve(project);
                    })
                    .catch(error => {
                        commit('clearProject');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearExecuteExport({ commit }) {
            commit('clearExecuteExport');
        },
        executeExport({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                interactiveLinkService.executeExport(payload.profile, payload.exportFormat)
                    .then(executeExport => {
                        commit('populateExecuteExport', executeExport);
                        resolve(executeExport);
                    })
                    .catch(error => {
                        commit('clearExecuteExport');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearCreateQuickViewUrl({ commit }) {
            commit('clearCreateQuickViewUrl');
        },
        createQuickViewUrl({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                interactiveLinkService.createQuickViewUrl(payload.domain, payload.parameters, payload.licenses)
                    .then(createQuickViewUrl => {
                        commit('populateCreateQuickViewUrl', createQuickViewUrl);
                        resolve(createQuickViewUrl);
                    })
                    .catch(error => {
                        commit('clearExecuteExport');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        }
    },
    mutations: {
        clearProjects(state) {
            state.status.listProjectsComplete = false;
            state.projects = [];
        },
        populateProjects(state, projects) {
            state.status.listProjectsComplete = true;
            state.projects = projects;
        },
        clearProject(state) {
            state.status.getProjectComplete = false;
            state.project = [];
        },
        populateProject(state, project) {
            state.status.getProjectComplete = true;
            state.project = project;
        },
        clearExecuteExport(state) {
            state.status.executeExportComplete = false;
            state.executeExport = {};
        },
        populateExecuteExport(state, executeExport) {
            state.status.executeExportComplete = true;
            state.executeExport = executeExport;
        },
        clearCreateQuickViewUrl(state) {
            state.status.createQuickViewUrlComplete = false;
            state.createQuickViewUrl = {};
        },
        populateCreateQuickViewUrl(state, createQuickViewUrl) {
            state.status.createQuickViewUrlComplete = true;
            state.createQuickViewUrl = createQuickViewUrl;
        }
    }
};
